import {
  useSnackbar as useNotistack,
  OptionsObject,
} from '@automata/rexports/notistack';

export type SnackbarOptions = OptionsObject;
export const useSnackbar = useNotistack;
